import { withDependencies, named } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import { SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { IEditorContextDefinition } from '@wix/site-service-editor-context/definition'
import { EditorContextDefinition as definition } from '@wix/site-service-editor-context/definition'
import { EditorContextService as impl } from '@wix/site-service-editor-context/implementations'
import type { SiteEditorContextServiceSiteConfig } from './types'
import { name } from './symbols'

export const SiteEditorContextService = withDependencies(
	[named(SiteFeatureConfigSymbol, name)],
	(siteFeatureConfig: SiteEditorContextServiceSiteConfig): ServiceProvider<IEditorContextDefinition, typeof impl> => {
		return {
			definition,
			impl,
			config: siteFeatureConfig,
			platformConfig: siteFeatureConfig,
		}
	}
)
